<svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="80 -880 800 800"
  width="24px"
  fill="currentColor"
>
  <path
    d="M480-280h80v-400H400v80h80v320ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"
  />
</svg>
